import styled from '@emotion/styled/macro'

import { flexCenter, pageContentDefaultSize } from 'style/emotion'
import mediaQuery from 'share/utils/mediaQuery'

const ViewTabs = styled('div')`
  ${pageContentDefaultSize}

  display: inline-block;
`

const ViewTitleContainer = styled('div')`
  ${flexCenter}

  height: auto;
  justify-content: flex-start;
`

const ViewTitle = styled('h2')`
  font-weight: 400;
  margin-right: 4px;
`

const ViewTooltip = styled('div')`
  margin-bottom: 4px;
`

const ViewTooltipIcon = styled('span')`
  font-size: 1.125rem;

  ${mediaQuery('mobile')} {
    font-size: 1rem;
  }
`

const ViewTabContent = styled('div')`
  margin-top: 24px;
`

export {
  ViewTabContent,
  ViewTabs,
  ViewTitle,
  ViewTitleContainer,
  ViewTooltip,
  ViewTooltipIcon
}
